import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '../../components/Button';
import BranchForm from '../../components/Branch/BranchForm';
import BreadCrumb from '../../components/Breadcrumb';
import * as actions from '../../redux/actions/actions-branch';

class addBranch extends Component {
  constructor(props) {
    super(props);

    if (props.match.params.id !== '0') {
      props.setForm(props.match.params.id);
    } else {
      props.resetForm();
    }
    this.state = {};
  }


  handleSubmit = (FormData) => {
    this.props.saveBranch(FormData);
  }


  render() {
    return (
      <>
        <div className="container">
          <BreadCrumb currentPage="Branch" />
          <div className="col-md-12 py-3 mb-5">
            <div className="card border-secondary">
              <div className="card-header">
                <div className="row">
                  <div className="col-md-10">
                    { this.props.match.params.id !== '0'
                      ? <span className="fa fa-pencil-alt cardTitle"> Edit Branch</span>
                      : <span className="fa fa-plus-square cardTitle"> Create New Branch</span>}
                  </div>
                  <div className="col-md-2 text-center">
                    <Button
                      className="btn btn-sm btn-secondary"
                      onClick={() => this.props.history.goBack()}
                    >
                      <span className="fa fa-arrow-left" />
                      {' '}
                      Back
                    </Button>
                  </div>
                </div>
              </div>
              <div className="card-body text-secondary">
                <BranchForm
                  onSubmit={this.handleSubmit}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

addBranch.propTypes = {
  formLoading: PropTypes.bool,
  formError: PropTypes.string,
  saveBranch: PropTypes.func
};

addBranch.defaultProps = {
  formLoading: null,
  formError: null,
  saveBranch: null
};

const mapStateToProps = ({ branch }) => ({});


const mapDispatchToProps = (dispatch) => ({
  saveBranch: (data) => dispatch(actions.saveBranch(data)),
  setForm: (id) => dispatch(actions.editBranch(id)),
  resetForm: () => dispatch(actions.resetForm())
});

export default connect(mapStateToProps, mapDispatchToProps)(addBranch);
